import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

const PopupTitle = ({ title, withLogo }) => {
  const { t } = useTranslation();

  return (
    <h2 className={styles.titleWrapper}>
      <span className={styles.title}>{title}</span>
      {withLogo && (
        <img
          className={styles.logo}
          src={new URL('../../../img/logo-blue.svg', import.meta.url).href}
          alt={t('blagoLogo')}
        />
      )}
    </h2>
  );
};

export default PopupTitle;
